/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import SelectDateFilter from 'modules/common/components/SelectDateFilter';
import moment from 'moment';
import PropTypes from 'prop-types';
import withDashboard from '../../../common/hoc/withDashboard';

import * as actions from '../action';
import * as c from '../constant';
import BplsChartComponent from '../components/BplsChartComponent';

const colors = ['#5272AA', '#7790CB', '#8AA4F8', '#A3B3F9'];

const renderLegends = (dt) =>
  dt.map((x) => {
    return (
      <div key={x.name} className="legend-item">
        <div
          style={{
            background: `${x.color}`,
            width: 20,
            height: 20,
            marginRight: 20,
          }}
        />
        <div className="legend-text">{x.name}</div>
      </div>
    );
  });

const payload = {
  period: 'MONTHLY',
  date_from: moment().startOf('year').format('YYYY-MM-DD'),
  date_to: moment().endOf('year').format('YYYY-MM-DD'),
  permit_type: 'GO! BPLS',
  // permit_type: 'Business Permit and Licensing System',
};

const filter = {
  transaction_type: 'ALL',
};

function BplsDashboardChartContainerE2E({
  graphStats,
  getGraphStatsE2E,
}) {
  const [filterData, setFilterData] = useState(filter);
  const [isLoading, setIsLoading] = useState(true);

  const handleOnSubmit = (data) => {
    const args = {
      ...data,
      module_type: 'BPLS',
      permit_type: 'GO! BPLS',
    }
    getGraphStatsE2E(args);
  };

  // const handleOnSubmit = ({ type, from, to }) => {
  //   getGraphStatsE2E({
  //     period: type,
  //     date_from: from,
  //     date_to: to,
  //     module_type: 'T_BPLS',
  //     permit_type: 'Business Permit Application (NEW & RENEWAL)',
  //   });
  // };

  const handleChangeSelect = (e) => {
    setFilterData({
      ...filterData,
      transaction_type: e ? e.value : '',
    });
  };

  const formatKey = [
    {
      key: 'INDIVIDUAL',
      color: `${colors[0]}`,
    },
    {
      key: 'CORPORATION',
      color: `${colors[1]}`,
    },
  ];

  useEffect(() => {
    getGraphStatsE2E(payload);
    setIsLoading(false);
    return () => {
      setIsLoading(false);
    };
  }, []);

  return (
    <div className="dashboard-card">
      <div className="row mb-3">
        <div className="col-12">
          <div className="main-text">Statistics</div>
        </div>
        <div className="stat-filters">
          <SelectDateFilter onSubmit={handleOnSubmit} />
        </div>
        <div className="col-12">
          <BplsChartComponent
            chartData={graphStats}
          />
        </div>
        <div className="legends-wrapper-v2 area px-3 w-100">
          <div
            className="render-chart-legends"
            style={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'row',
              flexWrap: 'wrap',
            }}
          >
            {renderLegends(c.BPLS_E2E)}
          </div>
        </div>
      </div>
    </div>
  );
}

BplsDashboardChartContainerE2E.propTypes = {
  graphStats: PropTypes.instanceOf(Object).isRequired,
  getGraphStatsE2E: PropTypes.instanceOf(Function).isRequired,
};

// const formatGraphData = (data) => {
//   const labels = [];
//   const values = [];

//   data.forEach((item, i) => {
//     const entries = Object.entries(item).filter(
//       (a) => ['name', 'included', 'RPT', 'BPLS'].indexOf(a[0]) < 0
//     );

//     if (i === 0) {
//       entries.forEach((entry, x) => {
//         labels[x] = {
//           key: entry[0],
//           color: colors[x],
//         };
//       });
//     }

//     values[i] = rename(
//       rename(
//         rename(item, 'OHP', 'Occupational / Health Permits'),
//         'CDL',
//         'Community Tax CertificateCTC / CEDULA'
//       ),
//       'PSA',
//       'Civil Registry Office'
//     );
//   });

//   return {
//     labels,
//     values,
//   };
// };

const mapStateToProps = ({ api }) => ({
  graphStats: _.get(api, `${c.GET_GRAPH_STATS_E2E}.list`) || [],
  transactionList: [
    {
      INDIVIDUAL: 812,
      CORPORATION: 340,
      name: 'JAN',
    },
    {
      INDIVIDUAL: 512,
      CORPORATION: 121,
      name: 'FEB',
    },
  ],
});

const enhance = _.flowRight([
  withDashboard,
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(BplsDashboardChartContainerE2E);
